import React from 'react';
import type { User } from '@supabase/supabase-js';
import AdminSidebar from '@/components/ui/AdminSidebar';

interface AdminLayoutProps {
  children: React.ReactNode;
  user?: User | null;
  onSignOut?: () => void | Promise<void>;
}

const AdminLayout: React.FC<AdminLayoutProps> = ({
  children,
  user,
  onSignOut,
}) => {
  return (
    <div className="flex min-h-screen flex-col bg-background md:flex-row">
      <AdminSidebar user={user} onSignOut={onSignOut} />
      <div className="min-w-0 flex-1 overflow-auto">
        <main className="flex-1">{children}</main>
      </div>
    </div>
  );
};

export default AdminLayout;
